/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useBooking } from "../useBooking";
import { useCart } from "../useCart";
import { useSelector } from "react-redux";
import { FlowType } from "../../store/slices/flowSlice";

export const useInvoice = () => {
  const flow = useSelector((state) => state.flow.activeFlow);

  const booking = useBooking();
  const cart = useCart();

  const adapters = {
    [FlowType.BOOKING]: {
      invoice: booking.invoice,
      setInvoice: booking.setInvoice,
    },
    [FlowType.CART]: {
      invoice: cart.invoice,
      setInvoice: cart.setInvoice,
    },
  };

  return adapters[flow] ?? {};
};
export default useInvoice;
